import gql from 'graphql-tag';

export const CREATE_FACEBOOK_ADS_MUTATION = gql`
  mutation CreateFacebookAdsMutation(
    $articleId: ID!
    $creativeIds: [Int!]!
    $audiences: [JSON!]!
    $startTime: String!
    $newFbCampaign: Boolean!
    $newAdSet: Boolean!
    $uploadSourceType: UploadSourceTypeEnum!
  ) {
    createFacebookAds(
      articleId: $articleId
      creativeIds: $creativeIds
      audiences: $audiences
      startTime: $startTime
      newFbCampaign: $newFbCampaign
      newAdSet: $newAdSet
      uploadSourceType: $uploadSourceType
    ) {
      longRunningJob {
        id
        progress
      }
      errors
    }
  }
`;
